import { ImageList, ImageListItem } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

export interface AImageListProps {
    files: File[];
    cols: number;
    gap: number;
    imgMaxHeight: number;
    imgMaxWidth: number;
    onImageClick?: (file: File) => void;
}

export default function AImageList({
    files,
    cols,
    gap,
    imgMaxHeight,
    imgMaxWidth,
    onImageClick,
}: AImageListProps) {
    const imageFiles = useMemo(
        () => files.filter((file) => file.type.startsWith('image/')),
        [files]
    );
    const [imageUrls, setImageUrls] = useState<string[]>([]);

    useEffect(() => {
        const urls = imageFiles.map((file) => URL.createObjectURL(file));
        setImageUrls(urls);

        return () => {
            urls.forEach(URL.revokeObjectURL);
        };
    }, [imageFiles]);

    return (
        <ImageList cols={cols} gap={gap}>
            {imageUrls.map((url, index) => (
                <ImageListItem
                    key={index}
                    onClick={() => onImageClick?.(imageFiles[index])}
                    style={{ cursor: 'pointer' }}
                >
                    <img
                        style={{ maxWidth: imgMaxWidth, maxHeight: imgMaxHeight }}
                        src={url}
                        alt={`Preview ${index}`}
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
}
